module.exports = __webpack_public_path__ + "static/media/date-picker.cb08972b.svg";